module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "profileGallery"
    }
  }, [_c('mu-card', [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle blueTitle",
      "title": _vm.$t('message.labelGallery')
    }
  }), _vm._v(" "), _c('mu-card-text', [(_vm.isOwner) ? _c('div', {
    attrs: {
      "id": "uploadImage"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "id": "uploadBtn",
      "label": _vm.$t('message.labelUploadPhoto'),
      "disabled": _vm.isUploadingImage
    },
    on: {
      "click": _vm.bindUploadEvent
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.chooseImage
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isUploadingImage) ? _c('mu-linear-progress', {
    staticClass: "uploadProgress",
    attrs: {
      "mode": "determinate",
      "size": 10,
      "value": _vm.uploadProgress
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "galleryScroller"
    }
  }, [_c('mu-grid-list', {
    staticClass: "scroller",
    attrs: {
      "cell-height": 250,
      "padding": 0
    }
  }, _vm._l((_vm.images), function(image, index) {
    return _c('mu-grid-tile', {
      key: 'image-' + index,
      staticClass: "item",
      class: {
        'isOwner': _vm.isOwner
      }
    }, [_c('img', {
      staticClass: "img",
      attrs: {
        "src": image.image_url
      }
    }), _vm._v(" "), (_vm.isOwner) ? _c('mu-icon-button', {
      attrs: {
        "slot": "action",
        "icon": "photo",
        "tooltip": "Set as profile picture",
        "tooltipPosition": "bottom-center"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.setAsProfile(image)
        }
      },
      slot: "action"
    }) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('mu-icon-button', {
      attrs: {
        "slot": "action",
        "icon": "delete"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteImage(index, image.image_id)
        }
      },
      slot: "action"
    }) : _vm._e()], 1)
  }), 1)], 1), _vm._v(" "), (_vm.profileImage) ? _c('avatar-uploader', {
    attrs: {
      "hideAvatar": true,
      "imageUrl": _vm.profileImage
    },
    on: {
      "destroyUploader": function($event) {
        _vm.profileImage = $event
      }
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43c1351d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/Gallery/Gallery.vue
// module id = 3697
// module chunks = 1